import { Component, Input, OnChanges, ChangeDetectionStrategy } from '@angular/core';

import { coinIcon, FALLBACK_COIN_ICON } from '@olv/ui-shared/utils/asset-balance.utils';

@Component({
  selector: 'app-currency-icon',
  standalone: true,
  imports: [],
  templateUrl: './currency-icon.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./currency-icon.component.scss'],
})
export class CurrencyIconComponent implements OnChanges {
  @Input({ required: true }) iconKey: string | null = null;
  @Input() networkIconKey: string | null = null;
  @Input() label = '';
  @Input() size = 29;

  assetIconMissing = false;
  networkIconMissing = false;

  ngOnChanges(): void {
    this.assetIconMissing = false;
    this.networkIconMissing = false;
  }

  get assetIcon(): string {
    return this.assetIconMissing ? FALLBACK_COIN_ICON : coinIcon(this.iconKey);
  }

  get networkIcon(): string | null {
    if (!this.networkIconKey) return null;
    return this.networkIconMissing ? FALLBACK_COIN_ICON : coinIcon(this.networkIconKey);
  }

  get badgeSize(): number {
    return Math.round(this.size * 0.55);
  }
}
